import React, { useEffect, useState } from 'react';
//import './ModelDetail.css';
import '../App.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DropDownStructure = ({ summary, details, expand = false }) => {  // Destructure props correctly
    return (
        <div>
            <hr></hr>
            {/* Collapsible Section */}
            <Accordion defaultExpanded={expand} className='accordion'>
                <AccordionSummary expandIcon={<ExpandMoreIcon  className='accordion-icon'/>}>
                    {summary}
                </AccordionSummary>
                <AccordionDetails className='accordiondetails'>
                    {details}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default DropDownStructure;